import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import HomePage from "../views/Home";
import AboutPage from "../views/About";
import Contactpage from "../views/Contact";
import ServicesPage from "../views/Services";
import PortfolioPage from "../views/Portfolio";
import PageShell from "../components/PageShell";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<PageShell />}>
      <Route index element={<HomePage />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="portfolio" element={<PortfolioPage />} />
      <Route path="contact" element={<Contactpage />} />
      <Route path="services" element={<ServicesPage />} />
    </Route>
  )
);

export default function Router() {
  return <RouterProvider router={router} />;
}
